import React from 'react';

// Treść opisu produktu (bez własnej karty i bez nagłówka — te trzyma ProductPanels).
//
// Treść generuje BACKEND (backend_api/product_description.py) i oddaje w polu
// `description_paragraphs`. Front tylko wyświetla. Dzięki temu ten sam tekst trafia
// do użytkownika i do danych strukturalnych (JSON-LD), więc nie mogą się rozjechać.
//
// UWAGA DLA WOŁAJĄCEGO: ten komponent ma być w DOM także wtedy, gdy sekcja jest
// ZWINIĘTA — ukryty wysokością, nie odmontowany. Dzięki temu widzi go bot
// i czytnik ekranu niezależnie od stanu zwinięcia. ProductPanels tego pilnuje.
//
// Backend zaznacza słowa kluczowe (nazwa modelu, ceny) gwiazdkami: **tekst**.
// To backend decyduje, CO jest kluczowe — front tylko zamienia znacznik na wyróżnienie.
// Dzielimy na pary (zwykły, wyróżniony), więc nieparzysta liczba gwiazdek nic nie psuje.
const highlight = (text) => String(text).split('**').map((part, i) => (
  i % 2 === 1
    ? <strong key={i} className="font-semibold text-blue-600">{part}</strong>
    : <React.Fragment key={i}>{part}</React.Fragment>
));

const ProductDescriptionBody = ({ paragraphs }) => {
  if (!paragraphs || paragraphs.length === 0) return null;

  return (
    <>
      {paragraphs.map((p, i) => (
        <p key={i} className="text-[15px] leading-7 text-gray-700 mb-3 last:mb-0">{highlight(p)}</p>
      ))}
    </>
  );
};

export default ProductDescriptionBody;
